module.exports = __webpack_public_path__ + "img/c.a1606365.png";